import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MailCollection} from "../../models/paylinks.model";
import {ModalService} from "../../../../services/modal.service";
import {PaymentLinksDataService} from "../../services/payment-links-data.service";

@Component({
  selector: 'app-send-mail-paylink-dialog',
  templateUrl: './send-mail-paylink-dialog.component.html',
  styleUrls: ['./send-mail-paylink-dialog.component.scss']
})
export class SendMailPaylinkDialogComponent {
  @Input() token: string | undefined

  @Output() sendMailSuccess: EventEmitter<void> = new EventEmitter<void>()

  mailCollection: MailCollection[] = [{id: '1', mail: ''}]
  isSending = false

  constructor(
    private modalService: ModalService,
    private paymentLinkDataService: PaymentLinksDataService
  ) {
  }


  get StatusButton(): boolean {
    const emailReg = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/
    const isDisabled =
      (this.mailCollection[0].mail.trim().length > 0 && emailReg.test(this.mailCollection[0].mail.trim())) &&
      !this.isSending
    return !isDisabled
  }

  addEmail() {
    this.mailCollection.push({id: this.mailCollection.length.toString(), mail: ''})
  }

  closeModal() {
    this.modalService.closeModal()
  }

  sendMail() {
    this.isSending = true
    let mailArray: string[] = []
    const emailReg = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/
    this.mailCollection.forEach(item => {
      if (emailReg.test(item.mail)) {
        mailArray.push(item.mail)
      }
    })

    if (this.token) {
      this.paymentLinkDataService.sendPaylinkMail(this.token, mailArray.join(',')).subscribe({
        next: () => {
          this.closeModal()
          this.isSending = false
          this.sendMailSuccess.emit()
          this.mailCollection = [{id: '1', mail: ''}]
        }
      })
    }
  }
}
